export enum GraphTimeWindow {
    Weekly = 7,
    Monthly = 30
}